const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNbConversationsEtrangere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.59,136.5s8.7,27.94,21.91,35.16c-.29-9.58-.63-18.58-.75-24.41-.34-16.12-23.51-30.56-47-26.87s-35.6,17.46-34.26,30.23c0,0-.11,8.77-.1,19.9C224.73,165.62,254.59,152,273.59,136.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.19,237.19s0,12.18-9.13,31.59-9.52,38.82-3.43,53.28,22.46,20.18,40,13.71,19.79-35.4,17.89-52.91-19-38.06-22.84-48.34-6.47-15.6-6.47-15.6-9.9,13.7-16,16.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.19,56.37S90.42,95,52.63,154.47s-34.8,136,11.12,192.78,133.69,49.34,207.18,85.32,154.57,28.58,189.32-47.66S442.6,280.2,433.6,192,345.07-25.43,166.19,56.37Z",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,56.37S90.42,95,52.63,154.47s-34.8,136,11.12,192.78,133.69,49.34,207.18,85.32,154.57,28.58,189.32-47.66S442.6,280.2,433.6,192,345.07-25.43,166.19,56.37Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Map--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.56,187.22c.49-.07.54-2.58.26-2.61C246.82,184.52,246.44,187.39,247.56,187.22Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38,223.61c.82-.3,6.11.81,6.11-.87,0-1.08-5.44-2.5-6.11-2a3.12,3.12,0,0,0,.85,1.92c0,.53-2.29-.06-2.49.5A1.21,1.21,0,0,0,141.38,223.61Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.37,256.69c-2.22.12-4.36-2.73-6.79-3.07-2.16-.3-2.29-.53-4.19.25,2.12-.87-3.42-3.43-3.45-3.44-.93-.25-1.88,2.27-2.72,1.91.17.07,1-2,.15-2.78s-2.36,1.1-2.44,1.05c.14.08,2.37-5.58-.35-7.06-2.62-1.72-4.77-1.4-7.15-2.59-2.22-1.12-2.42-3.87-5.54-3.67,1.27-.08-2.46-3.33-1.43-2.92-1.66-.66-4.87.74-7,.26-.85-.18-1.4-2.36-2.63-2.36-1.88,0-1.37,3.37-1.67,4-.87,1.91-1.22-5-.34-4.44-.63-.4-5,2.64-5.49,3-1,.74-1.38,2.18-2.4,2.48,1.72-.51-5.5-1.31-4-.74-4.57-1.74-2.48-2.33-3.72-6.36-.36-1.14.83-1.68-.14-2.72s-4.82-1.2-6-.44c-.84.46.11-3.16.48-3.54h0c1.49-1.51,2-5-.34-5.08-3.83-.1-1.94,3.29-4.32,4.47-7.16,3.56-7.48-6.51-7.25-10.74a1.64,1.64,0,0,0-.28-.16,1.64,1.64,0,0,1,.28.16c.39-7.45,5.76-5.43,10.24-4.91-1.18-.14-.18-1.92,1.18-2a10.6,10.6,0,0,1,3.69.81c2.26.67,1.69,0,3.37,2.85.66,1.14.92,4,2.4,4.47.13,0-.08-10.42.77-11.67,1.07-1.58,3.63-3.54,4.44-4.58,1.85-2.37.07.3.3-2.45,0-.29-.74-4.21.52-4.21-.49,0,.43,3.68.38,3.71,1.26-.87.44-2.15.5-3.14,0-.79,4.08-2.14,4.41-2.86.14-.3-1.95,0-1.95-.06,0-1.06,3.28-.88,3.76-1.21a9.79,9.79,0,0,1,1.39-3.82c1.48-1.53,5.17-1.19,6.31-3.53-.14.29.49,1.45,1.28,1.22-2.91.85-4.3,2.4-.81,1.88,1.78-.27,4.48-2,5.81-3,.08-.06-.61-.92-.51-1.52-.06.38-2.2,2.07-2.7,2-3.4-.62-1.78-2.9-3.1-3.78a2.22,2.22,0,0,1-1.13.21c-.36-1.22,4.11-2.14-.19-2.7-3-.39-4.45,3.93-6.49,3.93,1,0,5.51-5.48,7.64-6C153,171.52,165,170.65,164,168a8.46,8.46,0,0,0-.85-.43c-.83-.77,2.17-1.53-1.16-1.92a4.13,4.13,0,0,1-.09-1.11c-.32-.22-3.68,1.17-3.68,1.16-.26-1.22,3.11-1.36,3.49-2,0,.05-7.21-3.45-6.56-4.31,1.33-1.72,1.32.2.46-2.47-.24-.73-3.45-5.23-3.22-5.44-1.56,1.41-.68,4.62-3.4,4.63-3,0-2.71-3.44-2.71-5.41,0-.87-7.45-3.09-8-3.07-4.21.11-2.48.38-2.74,3.72-.05.57-.67,2.94-.61,3.28.5,2.59,2.64,3.42,1.33,6.74-.4,1-2.79,1.29-3,1.88-.23.79.93,1.59.75,2.53-.07.38.39,3.95.15,3.84-1.59-.75-.89.73-2.67-.86-2-1.79-.61-4.38-1.78-5.74-.46-.55-6.27-2.75-7.56-3.34a8.06,8.06,0,0,0-5.6-.88c.51-.08-.48-3-.7-3.33-1.26-2.14-2.62.24-1.86-4,.19-1.06,4.93-6.15,5-6,0-.21-3.88-1.66-3.85-1.73.54-1.29,3.83,2.3,4.73-.41-.41,1.25,5.21-1.22,3.81-2.23-.59-.42-3.89,0-3.69-1.55-.13,1,7.07,1.4,4.21-1.15-.1-.09,2.62,0,3.17,0,.38,0-1-1.32-.91-1.45.41-.41,1.85,2,3.74-.1,1.46-1.63-.76-1.8-.85-3.38,0-.18,2.25-.79,1.5-1.92-.57-.86-3.56-1.89-4.55-1.57-.69.22.25,3.58-1.62,4.67a2.37,2.37,0,0,1-.56-.87c-.79.05.71,2.92-.3,2.45s-1.1-2.51-1.26-2.65c-.4-.35-.93-1.64-1.6-2.24s-1.31,2.23-1.57,2.28c-1,.18.13-2.45.2-2.57.46-.86-2.43-.58-2.38-.53-.92-.8.63-1.24.79-1.49-.2.32-2.22-3.29-2.22-3.27-1.33-3-.43,0-.77-3.41.16,1.59,6.18-2.65,4.09-3.34s-5.16-.92-5.63.77c-.26,1-.11,4.8-.5,6.33-.13.49-1.77,1.28-1.2,3.23.23.76,4.61,1.75,2.55,3.42a.81.81,0,0,1,.85-.75c.06.13-2.24,4.34-2,4.16a31.19,31.19,0,0,1-2.64-2.7c-.12-.22,2.93-.69,3.09-.84,1.18-1.15-1.73-1.13-1.73-1.3,0-.33,1.56-.13,1-.56a3.45,3.45,0,0,0-4.93.83c-.54.72,4.29,2.56-1.52,3.31-2.65.34-3.73-1-6-1.53-.67-.16-.64-.86-1.85-1-.42,0-3.3,1.22-2.42,1.62.64.28,3-1.34,3.39-.93-1.56-1.71-1.85,4.82-2.86,4.29-.45-.24-.17-1.81-1.54-2.26-1.88-.63-6.14,1.31-7.54-.23-.68-.74,1.79-.92,1.6-1.36-.69-1.6-4.61-1.71-6-2.05s-2.45-1.13-3.72-1.27c-1.53-.16-2.11.93-3.53.93-.21,0,.29-1.9-.37-2a7.79,7.79,0,0,1-1.72,2c-1.36-.1-1.18-3.44-2.8-3.19,1.1-.17-2.31,2.42-2.08,2.29a45.31,45.31,0,0,1-4.49,2.51c-.85-.05,4.79-3.51,4.78-3.38.06-.68-4.88,1.41-5.43,1.71s0-.87-1-.53c-2.36.85-.68,1.58-1.25,2.2.23-.24-14.59-3.49-15.57-3.57-1.45-.12-10.46-1.14-11-1.76-1-1.08-3.57.07-4.75,1.36-.95,1-8,2.59-8.31,4.12-.72,3.21,6.77,3.81,7.34,5.56,0,.14-8.43-.32-9.36,1.9.32-.76,2.36,2.43,2.57,2.51,1,.36,6.12-.74,6.14-.71,1.44,1.43-1.69,3.37-2.46,4.09-.93.86-1-.53-2.12.93a18.13,18.13,0,0,1-2.11,1.71c.24-.22,1.7,3.05,1.75,3.09.89.78,3.62.77,3.3.45.86.86-.08,2.66.72,3.08.54.29,2.41.06,3.44.48-.92-.37,2.83-1.63,2.61-1-.51,1.54-6.66,9-7.56,8,1.08,1.19,12.17-6.3,12.17-8.07a3,3,0,0,0-1-.56c-.25-.63,6-5.83,5.78-3.81,0-.21-3.73,2.85-2.87,3.64.26.23,4.39-1.2,5-1.44s-1.5-2.11,0-2.38c.51-.09,2.48,1.07,2.56,1a.69.69,0,0,0-.88.55c.19.6,8.82.22,9.36.7-.26-.23,5.54,4.78,5.48,3.38a2.35,2.35,0,0,1-.18-1.6c2.76,2-1.29,2.56-1.28,2.44,0,.14,2.1,3.1,2,3.13.39-.21-.54-2.68.09-2.45a2,2,0,0,1,.17,1c.7.9.82-2,.73-1.8.15-.39.22,3.82-.22,3.76-.64-.09,3.67-.37,2.4.25.4-.2-1.57-1.37-.48-1.46,1.68-.14.36,1.42-.76,1.52a13.53,13.53,0,0,0,.2,2.45c.34.25,1.88-1.2,2.66-1.06s.64,3,1.07,3.6c.31.43,2.47,2.6,2.75,3a22.94,22.94,0,0,0,4.54,3.66c-.15-.12,5.68,4.8,2.47,4.8-.12,0-3.48-9.05-7.21-6.42.78-.55,5,5.52,5.29,6.3,1.56,4.48-1,9.69.74,14.58,1.19,3.35,4.33,5.47,6.45,7.77a29.1,29.1,0,0,1,3.37,5.1c1.49,2.52,1.82,3.16,1.52,4.6,0,.07,6.72,7.1,6.46,7.29.64-.46-6.66-13.64-6.45-13.67,2.64-.27,2.87,3.86,3.36,4.62,1.35,2.09,3.81,4,5.29,5.94,2.53,3.25,2.87,6.66,5.13,9,1.5,1.55,5,2.9,7,3.53,2.64.84,5.43.05,7.56,2.13h0c1,.93,2.51,1,3.19,1.65,1.87,1.72,2.64.86,4.39,2.66,1.18,1.21,1.52,2.32,2.2,3,1.12,1.1,3,3.19,4.69,3.31s1.15-1.86,2-1.66c3.76.89,3.08,5.93,1.56,9-1.64,3.35-3.74,3.93-1.89,7.31.13.24-1.83,3.42-1.64,4.41.36,1.88,4.56,7.45,5.54,9.4,1.88,3.7,4.28,4.08,6.94,7.1,2.43,2.76,1.66,5,1.24,8.76-.61,5.51-.77,10.93-1.94,16.27-.47,2.13-4.51,13.22-3,15.35.69,1,1-2.79,1.64-3s-.41,8.27-1.08,7.8c-.35-.25.39-2.75-.53-2.34.84-.37-1.72,3.53-1.73,3.57.1-1.1,1.31,1.34,1.36,1.73.08.68,1.48-.45,1.41.54.1-1.48-4.2,1.7-2.17,1.39a4.52,4.52,0,0,0,.92-.71c.3-.06-2.12,2.53-.5,2.79.32.05.49-1.66.94-1.21.95.95-1.81,3-1.16,3.78.13.16,1.48-.61,1.74-.07.08.17-.91.94-.75,1,.54.2,1.77-.53,2,.25s-2.4.06-1.5,1.34c.34.48,2.48-1.55,2.88-.22-.11-.38-2.4,1.2-2.48,1.3a25,25,0,0,1,2.82-.65c.2.44-3.13,1.73-3.22,1.35.1.43,2,1.62,2.32,1.32.52-.53-.69-.27-.26-.83.3-.4,2.86-1.82,3-2.2a1.47,1.47,0,0,0-.71,1.32,4.54,4.54,0,0,0,1.16.06c-.32-.36-.77,1.68-.65,1.62a1.62,1.62,0,0,1-.53-1.15c-.57-.25-.28,1.2-.36,1.14a.77.77,0,0,0-.93-.52c.47-.66-.58,2-.58,1.09,0-.51,1.62,1.49,1.58,1.45a3,3,0,0,0,.45-1.08,29.91,29.91,0,0,0,2.69,1.86c.5.15-.36-1.17-.07-1.13a16.79,16.79,0,0,0,3.88-.8c-1.8-.66-4-3.86-4.34-4h0c-.27-.07-1.29.15-1.14-.54s1.11.24,1.36,0-1.13-2.37-.84-3c.45-1,1.24-1.28,1.75-2.21.68-1.24,2.36-2.19,2.46-3.57.09-1.09-1.57-1.11-1.49-1.42.31-1.2,1.08-4.14,2.32-5.7.47-.6,2.07-2.17,2.06-2.18-.39-.33-3.45-.06-1.84-2.49-.51.76,3.65-.66,3.44-.54.57-.33-.08-2.25.21-2.56,1.42-1.51,6.65.68,7.24-3.35.13-.89-2.32-4-2.37-3.94.83-.87,4.7,1,6.83-1.26.53-.56,3.18-5.25,3.17-5.11a9.61,9.61,0,0,1-1,1.95c0-.93,3.11-3.5,3.51-4.58.58-1.54-.12-3.55.68-5,1.61-2.82,5.22-2.28,7.22-3.54,2.57-1.63,3.31-4,4.1-7,.49-1.86,0-6.6,1-8.09C185.56,267.51,195.72,256.33,189.37,256.69Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,220.57c1.47-2-15.15-5.58-13.07-2.55-1-1.45,6.63.49,7,.69C135.17,219.42,138.19,223,140,220.57Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,223.3c.23.43,2.38,1,2.6.5S134.42,222.76,134.7,223.3Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.25,223.42c.5.87,2,.35,2.09,0C151.57,222.8,148.74,222.56,149.25,223.42Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,330.48c.68.37,2.09-1.49,1.47-1.61S156.69,330.13,157.34,330.48Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,330.61c.45.24,2.31-.61,2.09-1.06C160.68,328.62,158.58,330.36,159,330.61Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06,249.3c-.57.93.56,1.84.79,1.43S118.63,248.37,118.06,249.3Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.87,130.7c.12-2.24-3.31-1.15-3.82-1S168.71,133.44,168.87,130.7Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.31,129.17c-.41.25-5.46-.54-5.49-.45.13-.34,1.83-2.29,1.61-2.37,1.11.42,4.3,4.21,4.45.7C208,125,205,125,204.56,123.3c-.13-.47,3.9,1.3,3.09-1.2-.45-1.42-4.41,1-4.25-.52-.06.53,1.37-1.86,1.12-1.59,1.26-1.39,7,3.4,3.29-1.41-.15-.19,3.33-.13,3.5-.84s-3.46-.61-2.64-2c1-1.7,3.63.77,2-2.71.06.12-4.19-1.33-3.54-2s5.64,0,5.45-.77c-.48-1.82-2.95.1-3.15-1.46-.11-.81,1.5,0,1.74-.42.9-1.42-3.9-.27-3.73-.14-1.3-1,5.32-7.17,5.51-6.91-1.21-1.62-2.32,1.08-3.18.23s4.79-1.56,4.94-1.66c.48-.3-3-1-3.17-.77.61-1,8.76-.91,8.76-3.16,0-3-7.73-.12-8.59.16-.68.21-1.66-.67-2.13-.49-1.55.59-3,3.11-4.64,3.35,1.63-.24,3.48-4.18.82-4.65-.42-.07-4.92,3.25-5.2,2.25-.22-.79,2.71-1.16,2.64-1.82-.14-1.4-9.56.79-9.58.58-.14-1.91,13.12-1.14,14.45-2.94.74-1-16.86-3.84-18.45-3.43-.4.1-2.79.95-3.06,1a12.13,12.13,0,0,0-1.66-.09c-3,.34-5.91.14-8.9.71-.37.07,1.3,1.19,1.28,1.29s-2.62.27-2.26.74c-.08-.1,3.68,2.67,3.42,2.73-2.11.45-6-4.37-8.1-2.81-.52.38,1.55,1.65,1.55,1.94,0,1.16-4.24-1.32-4.12-1.32-.31,0-.19,2.53-.79,2.91,1.83-1.14-2.26-2.75-2.9-2.81a3.42,3.42,0,0,0-3.37,1.94c-.95.33-2.35-.82-3.58-.32-.88.36.78,1.84-.44,2.51-.33.18-8.88.39-7.74,3,.86,2,5.48-.09,1.38,3.26-1.12.91-4.36.54-5.77,1.5-6.55,4.47,6.06,1.52,5.93,4,0,.28-6.69.29-6.56.91.17.91,4.68,3,5.88,3.11,2.43.23,4.76-1.59,8,0,2.84,1.37,5.71,4.18,6.56,7.35,1,3.71-1.36,4.18,2.53,4.18a22,22,0,0,0,3.32,3.57c-.14.11-4.34-1.66-4.34-.59,0,2.5,5.86.67,4.3,5.13-.24.66-2.09-.28-2.64,1.07a6.68,6.68,0,0,0-.66,2.86c-.09,1.8,2.61,8,4.6,10.76,1.6,2.19,2.55,2.53,4.81,3.55,3.54,1.59,2.72,1.79,4.72-1.17.77-1.16-.42-2.28-.11-3.18.16-.47,1.69-.46,1.92-1.47.29-1.3.11-3.45.28-4a2.6,2.6,0,0,1,1.26.17c.17-.1,2.37-3.06,2.63-3.06a.93.93,0,0,1,.17,1.19c.43,1.35,5.48-3.15,5.58-3.23,1.93-1.4,1.65-1.49,3.37-2.25C199.92,132.43,204.21,131,207.31,129.17Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,113.7c1.1-.6,1.1,0,1.93-.87a4.23,4.23,0,0,0,.9,1.12c1.31,0,1.84-2.82,2.66-3s.25,2.5,2.14.67c.72-.69.56-1.33,1.26-2.1.19-.21-4-.07-4.56.12C81.12,110.2,78.32,113.74,78.38,113.7Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.76,112.58c-1.89.15,1,1.38.94,1.08a4.19,4.19,0,0,0-2.19.64c-.34.48,1.89.3,1.65.39a4.17,4.17,0,0,0-2.27.81c1.21,1.77,3.27.09,4.23-.51-.5.31,2.94,1.16,3.17.81-.33.49-3.56.94-3.51,1.46.18,1.68,6.45-.55,7.38-1,3.11-1.36,4-.26,2.56-3,.13.22-3.36-2.19-3.91-1.9-1.62.84,1,2.52.61,3.11-.93,1.53-4.07-1.72-4.81-1.91C88.7,112.16,88.34,112.46,86.76,112.58Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93,125.92c2.29,1.72,5-4.71,3.52-4.79a1.08,1.08,0,0,0-.27,1.35c.16-.34-1.88-1-1.84-1-.44-.69,2.91-1.32.74-2.79-1.61-1.1-1.42.94-1.39.93.28-.14-4.82-.59-3.2.87a10.48,10.48,0,0,0,1.67.32c1.92,1.67-3.34.77-2.8.67C102.83,121.8,107.46,125.57,107.93,125.92Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,124.81A25.9,25.9,0,0,1,77.65,127c1.38,0,2.83-2,3.51-2.52,1.78-1.33,4.31-2.63,6.11-4.12.67-.55-8.21-3.1-9.37-2.74-3.72,1.17-.48.37-1.69,2.42-.38.63-2.38,3.93-2.13,4.24A4.67,4.67,0,0,0,75.84,124.81Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.63,114.63c1,.12,2-.87,2-1.43S82.12,114.57,82.63,114.63Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.68,127a1.08,1.08,0,0,0,1.08-1.12c.24.82-4.27-1.54-4.68-1.68-1-.34-.37-1.26-2-1.63-1.11-.25-2.81,1.4-2.76,1.41-1.5-.53-.87.11-2.57.11-1.25,0,.86-6.85-4.57-3.57-3.28,2-.56,3-.41,5.12,0,.35-2.45-.73-2.35-2.32.09-1.44,1.89-2.73,1.89-3.64,0-1.68-5.91,2-6.2,3.34-.39,1.76,2.15,5.28,3.19,3.9-.27.35-2.77-.33-2.7.33.36,3.61,13.37,1.36,13.65,2.09a1.5,1.5,0,0,1-.66-1c.18-.6,4.58,2.73,4.61,3a3.62,3.62,0,0,0-1.25,1.18c.84.7,1.77-.71,3.17.74,1.58,1.64,1.55,1.3,1.93,3.79.08.52,4.78-1,3.93,1.17s-2.1-.56-2.72-.36-2.23.26-3.09.52a4.15,4.15,0,0,0,.52,1.58c-1.33.65-3.49.07-4.51,1-3.75,3.21,4,1.26,5.07,1.6s7.55,8.26,9.23,6c.42-.58-2.85-4.12-3.46-4,2.48-.72,6.12,3.38,4.82-.77-.58-1.85-5-3.28-3.06-5.59.8-1,4.14,3.13,4.7,3.11,0,0,3.28-3.44,3.28-3.42,0-2.3-9.06-3.54-8.77-5.77a4.84,4.84,0,0,1,1.75-.43,2.9,2.9,0,0,0-1.47-.81c-.15-1.37,1.45-1.3-.85-1.3,1.67,0-2.31-1.81-2.46-1.87C144.49,127.56,142.68,127,142.68,127Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,164.9c-1.05.61,1.31,3.5,1.94,3.07C67,167.83,66.41,164,64.87,164.9Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.44,115.87c.39-.5-.85-1.55-1.19-.68S102,116.38,102.44,115.87Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,149.14c.4-.07,1.19-1.62.17-1.56S132.39,149.23,133,149.14Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.66,135.92c3.09-.57-3-2.8-2-1.94C137.33,134.53,134.94,136.6,138.66,135.92Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,147.77c.91.62,2.26-1.05,2.15-1.55S126.93,147,128,147.77Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,116c.52,1.6,13.45,2.26,14.95,1.17,6-4.33-12.67-2.16-12.42-3.57a5.29,5.29,0,0,1,1-1c.46-.61-10.15-2.75-9.34-1.49C113.57,114.51,115.66,111.3,117.15,116Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.14,129.9c.3-.39,1.75.8,1.81-.06,0-.61-4.31-3.68-4.69-4.66a23.17,23.17,0,0,1-.29-4c.51-.46.46-1-.17-1.45a2.34,2.34,0,0,0-2.49.62,7.7,7.7,0,0,1,1.58,1.49c0-.29-2.83-1.31-3.11-.75-.4.8,1.29,3.7.75,4-.1,0-3.82-4.18-4-3.23a4.78,4.78,0,0,1,1,1.18c0,.15-2.06.06-1.95.35-1.49-3.94-2.72.78-4.07-.49-.14-.14,2.32-2-.58-2-1.12,0-4,1.61-4.37,2.55-1.68,4,2.09,1.06,3.67,2.28.08.06-3.34.95-3.34,1.42,0,2.1,8.09-.21,8.09,1.56,0,.43-7.29,0-7,1.18.75,3.26,10,2.61,11.88,2.35a14.24,14.24,0,0,1,3-.41c.63,0,5.81,1.78,5.19-.33-.5-1.65-1.69.5-2.1-.62A4.58,4.58,0,0,1,104.14,129.9Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,172.6c.11.49,3.4,2,3.51,1.3S152.71,172.17,152.81,172.6Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,108.67c-1-.56-2.3.62-1.24,1.06C119.7,110.1,121.06,109.23,120,108.67Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21,107.87c6.66,0-1.2-3.71-1.64-3S110.43,107.87,111.21,107.87Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89,101.72c.06,0,5.25,2.43,5,1.61.14.42-2.39,1-2.26,1.18,1.66,1.83,4.27,3,6.62,2.36.16,0,4.89-4.26,4.75-3.54-.19,1-3.49-3.34-3.67-3.48s-7.19-3.82-7.87-3.3a1,1,0,0,0,.84.73c0,.39-1.72.08-1.88.4q.48.38.93.78c-.34.66-2.32-.32-2.25,1a4.25,4.25,0,0,0,1.55,1.17C113.69,101.33,109.9,100.63,111.89,101.72Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59,119.78c-1.43,3.38,5.77,2.6,5.77,1.86C137.36,120.51,132,118.82,131.59,119.78Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,108.18c-.12-.38-4.41.19-3.74.74C113.19,109.85,115.91,108.55,115.8,108.18Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,108.11c.29-.74-1.87-.62-1.69-.37C88.4,108.3,89.42,108.86,89.7,108.11Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.55,114.88c-.91-.75-3.6,1.05-3.23,1.36C112.79,117.49,117.88,117.62,114.55,114.88Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48,109.91c.45-.62-1.82-2.6-1.93-1.67S101,110.57,101.48,109.91Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.46,111c-1.35-.57.57,2,.36,2a5,5,0,0,0-2.15-1c-.48.39.7,1.57.31,1.76-.61.29-2.1-2.57-2.94-2.62-1.8-.1.64,2.56.72,2.61,1.51.91,2.7.21,4.21.62-.21-.06,1.67,4.79,3.44.5C111.7,111.7,108,111.62,106.46,111Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,107.8c1-.16-4-1.35-4,.56C90.38,111.6,94.41,107.8,94.4,107.8Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63,106.62c.46.21,3.68.17,3.68-.49,0-2.41-5.34.26-5.21.37A5.59,5.59,0,0,0,91.63,106.62Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,101.78c.4-.74-2.38-1.33-1.69-.68C107.53,101.47,108.44,102.53,108.83,101.78Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.08,104.7c.91-.3,1.48,0,1.7.87-.11.27-2.1.19-2,.37s10.89,4.43,5.38-1a5.73,5.73,0,0,0-2.61-1.41C98.68,102.93,101.48,104.41,101.08,104.7Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,144.36c.11-.65-5.53-4.51-5.83-4.47-.54.07-3.17,3.6-2.83,4.72S132.15,144.06,132.1,144.36Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74,95.58c2-1.44.35.6.37.63a5.36,5.36,0,0,1,1.2.19c-2.26,2.65,4.22,2.22,4.19,1.72.29,4.12,8.26-1.38,9.22-.7,1.84,1.31-4.84,2.6-4.68,2.82,0,0,2.15,1.82,1.88,1.83-1.27.1-7.91-4.62-6.79-.42.26,1,5.48,3,5.48,3.92,0,0-6.58-2-6.74.87-.1,1.78,3.63-.32,3.67-.21-.58-1.29.58,4,.58,3,0,1.2-5.1-3.12-4.89-.74a11.13,11.13,0,0,0,1.5,1.16c0,.41-4.38.77-3.35,1.81,1.18,1.21,14.49,1.58,15.16,0s-5-1.18-5.25-1.6c.79,1.24,5-2.25,5.33-2.41,2.12-1.17,3,.55,4.12-2.76.33-1-3.67-1-3.63-1,2.33-1.65,5.4-1,7.52-2,1.29-.64,8.93-4.59,9-5.17s-3.58-.15-3.79-.24c1.76.77,8-3.38,8.1-3.36-.5-.16-7.74-2.62-7.86-.76a2.76,2.76,0,0,1,1.17-1c-1.42.56-8.53.18-9.49.23-3.26.17-6.41-.43-9.28.36-.58.16-13.92,4.54-14.17,4A1.26,1.26,0,0,0,118.74,95.58Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,170a7,7,0,0,0-2.72,3.14c-.14.3-2.63,2.8-1.62,3.4,2.29,1.34,4.4-2,4.64,1-.08-1,3.32.37,3.47.08-.06.13-1-2.6-.55-2.4.61.28-4.51-3.26-4.44-2.67A5.58,5.58,0,0,1,164,170Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71,166c.68-.31,1-.69.68-1.06S20.19,166.26,20.71,166Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.52,163.22c-.79-.31-1.59.95-1.7.94C23.48,164.1,26.28,163.53,25.52,163.22Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.88,156.33c-1.3,1.64-2.37,4.78.4,2C39.69,157.91,40.29,154.56,38.88,156.33Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.84,152.27c-.53-.32-.91-.17-1.13.43a1.75,1.75,0,0,0,1.78.59C24.41,152.59,21.83,152.16,21.84,152.27Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,190.16c-.09-.7-1.39.21-1.11.41C239.46,191,240.1,190.86,240,190.16Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.74,197.19c0-.46-3.66,0-3.58,0C264.69,197.15,268.85,198.39,268.74,197.19Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.31,197.71a12,12,0,0,1,.94-1.19,11.76,11.76,0,0,0-2.9,1C275.85,198.48,278.42,198.37,278.31,197.71Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.22,143.24c4-.22.24-6.33-1.68-5.21-.44.25-3.26,1.82-3.77,1.67a1,1,0,0,0-.9-.69c-2.51,3,.09-.86-3.37-.86-.72,0,.37,1,.18,1-.7-.08-1.76-.29-1.93,1-.08.57,2.88.44,2.77.33s-.29,1.06-.19,1c-.08.05-2.37.1-2.17.51.07.14,2.09.21,2.44.62.64.74-.69,1.66-.83,1.51C209.19,146.8,213.63,143.39,216.22,143.24Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,169.39c3.36,0,4.28-2.42,3.95-5-.11-.88,1.69-1-.33-2.11a7.88,7.88,0,0,0-2.64.56c-.06,1.8.13.21-1.79,1.26C222.84,164.16,222.88,169.39,223.71,169.39Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,152.59c.32-.35.7-1.7.21-1.55S233.87,152.74,234,152.59Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.56,155.84c-.25-.27-1.23,1.25-.85,1.24S227.8,156.11,227.56,155.84Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,157.7c1.23-1.08.07,4.15.07,3.48,0-.94,1.62.46,1.44.49a2.08,2.08,0,0,0,.73-1.09c.57.09-.37,2.24-.36,2.38.11.84,2.16-.53,2.28-.31,1.35,2.35-1.08,3.33-1,4.88A1.79,1.79,0,0,0,229,169a17.21,17.21,0,0,0,3.15.46c.07.38-4.45,1.31-3.34,2.79,0,0,8.12-1.78,8.6-2.27s-.83-.18-.79-.53c.22-1.63,1.5-.87.79-2.65a4.65,4.65,0,0,1-1.58-1.24c-.91-1.54-1.8-4.85-4-4.69,0,0,1.42-2.36,1.27-2.73-.62-1.58-1.79.22-2.67-.84-.3-.35,1.81-1.76,1.19-2.34C231.19,154.48,227.33,157.62,227.24,157.7Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37,162.81c-.24-.06,3.2-.93,1.56-2.05C250.53,159.8,250.23,162.78,250.37,162.81Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,157c-.72,0-1,1.56-.87,1.82S260.23,156.94,259.52,157Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.52,156.54a3.66,3.66,0,0,0,1.32-.95C265.76,154.57,262.1,156.62,263.52,156.54Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,154.72c.15-.31-1.09-.17-.81.11A.53.53,0,0,0,264.59,154.72Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,100.88c1.07.92,3.16-.14,4.49.69-.05,0-2.67,1-2.66,1,.65,1.68,10,.82,9.37-1.77-.08-.31-6.1-1.16-5.86-1.24a1.13,1.13,0,0,0-.22,1.36c-.5.37-2.92-1.62-3.46-1.55a4,4,0,0,0-.82,1.12l-1-.75C257.82,99.73,258.89,100.75,259.05,100.88Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21,103.4c-1.92-.45,1,3,1.46,3.23.89.51,1.6-1.65,2.24-1.9s-.27,1.18.35,1.14a4.94,4.94,0,0,1,1.36-.58c.55.86-4,2.52-3.39,2.68,1.15.29,2.39-.46,3.58-.17a18.8,18.8,0,0,0-3.51,1.12c-.11,1.12,2,1.07,2.52,1.27a.86.86,0,0,1-.62.53c-.29.39,1.59.58,1.89.4a29,29,0,0,0,2-3c.23-.29,2.05-4.65,3.18-2.86-.3-.48.46,3.8.05,3.72.48.1,4.8.83,4.63-1.18.09,1-4.47-3.33-4.39-3.27-1.42-1.16-3.54-1.35-4.55-1.6.59.14-.94-1.9-1.67-2.14-1.06-.35.24,3.77.31,3.44,1-4.24-2.95-.91-2.92-.92a7.31,7.31,0,0,0-1.18-1,4.38,4.38,0,0,1,1.07-.44C253.29,102,246.32,102.27,251.21,103.4Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,105.91a5,5,0,0,0,.9.68c-.42,0-.88-2.17-1.7-1.92A1.08,1.08,0,0,0,250.05,105.91Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.25,145.23a2.2,2.2,0,0,0-1.58.53c.25.31,3.92,1.17,3.92.34A3.57,3.57,0,0,0,477.25,145.23Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,184.2c-.19-1.26-3,4.14-1.59,3.36-.25.14,1.18-.8,1.14-.59-.24-.35-.49-.7-.75-1,0,.3,8.14.23,7.73-3.31.22,1.92-6.81-1.26-6-1.81C415.61,180.78,415,184,415,184.2Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.94,201.62c.4.81.78-1.13,1-.16,0,.14-.54,3.06.4,2.85.77-.17,2.16-2.95,1-3.45C402,200.75,398.92,199.57,399.94,201.62Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.43,201.29c.28-1.23,2,.23,2-1.7,0-1-2,0-2.1.18C404,200.38,404.15,202.49,404.43,201.29Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.22,197.11s-6.22.28-5.74,2.46c.06.28,5.24-.49,5.61-.57-1.16.27,1.11.82,1.38.8.88-.07.21-1.28.37-1.38,1-.61,4,.54,5-.85.8-1.09,2.62-8.59,1.21-9.4-1.77-1-2.65,4.68-3.48,5.84C410.9,194.93,407.41,195.18,407.22,197.11Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.11,222.8a13.29,13.29,0,0,0,.68-1.65c-.15-.57-3.35-.14-2.7,1.09C373.16,222.39,375,224.89,375.11,222.8Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.35,217.8c.62-.47,2.08-3.63,1.59-4.35C388.3,211.06,387,218.87,388.35,217.8Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.18,226.44c-.87,2.88,8.43,6.73,6.51,8.94,3.09-3.55-3.55-5-4.23-6.62s2.39-3.94,0-5.33C387.86,222.48,387.22,226.32,387.18,226.44Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.56,235.46a8,8,0,0,0-1.62,2.32c-.16-.31,3.27-2.47,2.64-3.85A2.13,2.13,0,0,0,385.56,235.46Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9,230.66c.11.58.38,1.78,1.21,1.49S387.82,230.25,387.9,230.66Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22,235.63c-.3-.41-1.05.35-.94.66S393.52,236,393.22,235.63Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.47,236.33s-5.5,3.57-4.57,3.48,1.31-1.39,2.26-.72.37,2.83,2.19,2.83c-1.36,0,1.45-2.91,1.32-2.4A3.07,3.07,0,0,0,394.47,236.33Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.94,232.77a1.38,1.38,0,0,0,.07,1.91c2.37-.52-.83,1.8,1,2.23C392.58,237.29,392.69,232.17,389.94,232.77Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.05,256.56c0,1.64-4.21.62-4.27,1.12-.23,2.38,6.48.08,5.1-1.65C428.42,255.89,428.14,256.06,428.05,256.56Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.75,256.4c1.13-.33-.88-1.76-1.12-1.82C429,254.66,429.38,256.5,429.75,256.4Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,259.29c1,.07-3.25-3.54-4.23-4.1-2.2-1.25-6.47-3.19-8.67-3.06-.64,0-1.53,2-2.31,1.86-1.57-.29-.67-2-1.79-2.43-1-.39-1-1.46-2.69-1.21-.29.05-1.93,1.34-1.35,1.47.32.07,3.64,1.92,3.66,1.35,0,.26-2,.25-2.22.28-.92.17,3.46,2.32,3.74,2.45,1.93.94,3.33.74,4.45,2.71s-1.57,1.86-1.12,2.75c.83,1.63,6.93.19,7.58.2,1.78,0,1.75-.06,4,1.05-.06,0,5.47,2.76,4.88,1.78C426.16,264,421.39,259.23,422.5,259.29Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.83,235.92c-.82.1-.84,4.87.11,5.25C340.59,242.25,340,235.66,337.83,235.92Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,266.45c0,.05-1.77,3.09-2.07,3.4-.8.8-2.9,1.29-3.53,2-1.74,2-.57,2.91-.87,5.87-.22,2.09-2.68,10.53,3,7.78,3.25-1.58,2.58-10.87,3.8-13.92.16-.4,1,.9,1-.79S298.09,267.92,297.72,266.45Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.26,231.89c.42.48,1.25-.08,1.3-.27S302.78,231.35,303.26,231.89Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.41,263.11c.11.62,1,1,1.3.78S438.29,262.47,438.41,263.11Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.39,259.29c0,.16.87,1.12,1.07,1S434.44,259,434.39,259.29Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.63,261.78c.31-.22-1.75-1.46-1.78-1.06S438.32,262,438.63,261.78Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,257.56c-.07.37,1.14,2.34,1.59,2C434.39,259,432.05,257.19,432,257.56Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.74,261.72c-.29.68.84,1.86,1,1.89S440,261.19,439.74,261.72Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.73,264.48c0,.15.79.9,1.16.62S440.63,264.21,440.73,264.48Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.29,266.46c.28.25,1.69-.06,1.64-.43S399.86,266.09,400.29,266.46Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.28,290.33s-.68-4.1-.33-3.94c-2.41-1.13-5.92-6.15-7.66-8.8-1.31-2-1.71-4.13-2.76-6.62-.54-1.29-1.66-.32-2-1.16-.56-1.23,0-3.8-1.21-4.93-.92-.86-1.41,6.15-1.42,6.18-1.28,3.64-.52,3.7-3.8,2.54-.94-.34-3.77-1.79-4-3-.21-1.05,2.26-2.82,1.93-3.48.25.5-5.94-1.76-6.07-1.7q-.24.6.48.93c-1.7-2-4.5,5.12-3.66,5,.4-.05-2.53-.46-1.72,0-2.1-1.22-1.78-2.43-4.29-.63-1.63,1.18-1.05,2.76-2,3.81-.25.28-.42-1.43-.81-1.17-1.35.91-.3,2.08-1.52,3.08-1.51,1.23-2.27,1.31-3.93,2.14-2.18,1.07-3.73,1.4-5.62,3.18a.93.93,0,0,1-.14-.87c0,.45-.54,1.86-.6,2.61s.72,3.65.51,4.09a1.5,1.5,0,0,1-.76-.71,5.9,5.9,0,0,1,.37,1c-.31-.24-.61-.49-.91-.74-.36.9,2.36,5.69,2.62,6.76.13.55.1,5.73-.13,5.25,1.74,3.57,4.26,1.13,7.14.28,2.36-.69,3.88-1.19,6.16-2.05,1.76-.66,5.5-2,7.42-1.68,1.18.19,7.08,4.81,5.73,5.42.41-.18,2.84-3.2,3-3.06.76.71-1.23,2.63-1.33,3.07-.36,1.73,2-1.36,1.36-.86.85-.68.45,2.11.37,1.89s2.79,3.69,3.06,3.91c1.62,1.4,5.65.1,5.61.08a2.48,2.48,0,0,1,0,.94c-.37-.46,1.34.57,1.75,1-.83-.79,4.74-2.53,4.58-2.35.85-1,1.34-5.39,2-6.82C428.11,297.75,429.79,290.73,430.28,290.33Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3,302.77c.31.31,1.35.22,1.52-.22S408,302.49,408.3,302.77Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.09,311.4a10.24,10.24,0,0,1-2.18-.69c.38-.11.07,5.86,3.26,4.18C423.78,314,424.4,311,421.09,311.4Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.48,321.82c.2.06.85-.12.48-.62S448,321.68,448.48,321.82Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.27,306.12c-.76,1.39-2.42-2.09-2.57-2.08a.73.73,0,0,0,0,.78c.13-.2-2.51-3.79-3.06-3.79-.06,0,1.9,3.88,2.07,4.36.59,1.72-1.35,1.65-1.28,2.59,0-.07,1.41,4,1.33,3.91C459.38,314.93,462.83,303.26,461.27,306.12Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.66,311.12c-1.59-1.24-11.15,7.3-8.26,9.24S458,312.2,456.66,311.12Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.94,274c.31.13,1.33-.24,1.33-.77S462.47,273.85,462.94,274Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.19,275.68c.48.5,1.44.46,1.47-.43S460.76,275.24,461.19,275.68Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.15,99.59a2.07,2.07,0,0,0-1.2.75c.53,1.16,5.42-1.17,5.44-1.5C301.47,97.3,297.44,99.15,297.15,99.59Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.21,100.25c0-.66-2,.07-1.58.21S304.21,100.91,304.21,100.25Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.34,99.26a5.2,5.2,0,0,1,2.15-.46c.25-.68-4.36,0-4.22.38A1.39,1.39,0,0,0,295.34,99.26Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.27,132.32c1.1,1.11,1.77-.5,2.34-.74C300.39,131.27,295.24,130.26,297.27,132.32Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.38,119.82a47.11,47.11,0,0,0-4.3,4.8c0,.12,2.18,1.94,2,2-.19-.39-.12-.68.21-.86-.2,0,5.46,4.74,5.71,2,.07-.73-2.49-2.3-2.6-3.32s1-2.07,1.43-3a15.58,15.58,0,0,1,2.57-3.39c1.68-1.55,13.86-6.66,13.32-7.12-1.3-1.11-12.16,2.44-13.92,3.54C308.85,115.13,305.41,119.82,305.38,119.82Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5,117.22a3.42,3.42,0,0,0,3.06-.67C427.82,113.7,415.25,116.55,424.5,117.22Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.84,118.66c0-.62-2,.23-1.2.54C414.09,119.37,414.84,119.28,414.84,118.66Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.3,107.58c.76.47,7.54-.66,7.77-2s-3.93-1.72-3.8-.68C364.52,99,362.28,108.19,361.3,107.58Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.45,101.74a3.58,3.58,0,0,0-.87,1.24c1.9,1.82,6.53,3.22,6.93,0C361.85,100.25,355.45,101,355.45,101.74Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45,100.58c1.23.57-1.08.63-1.22.71-.66.33,2.45.15,3-.08s4.68-1.44,3.92-2.37C356.1,95,352.86,100.31,353.45,100.58Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.6,117.92c-.87,1.91,1.53.57,1.55.25A1,1,0,0,0,377.6,117.92Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,98.72c.61.68,4.29.75,4.45-.45.05-.41-3.06-1-3.25-.93C306.81,97.26,305.41,99.08,305.08,98.72Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.47,97.65c.15-.62-2.35-.35-1.7.24C351,98.1,352.32,98.27,352.47,97.65Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.33,127.6c.17.13,3.5-.1,2.84-.88-1.56-1.87-4.9.79-4.65.92C464.12,127.61,464.72,127.6,465.33,127.6Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,116.1a6,6,0,0,0,4.12.83c1-.19,3.61-1.73,2.62-2.08.47.17,1.85,3.32,2.66.88.68-2-1.24-1.54-3-2.11-.15-.05-3.25-.13-3.27-.13C413.6,113.4,407.07,114.51,410,116.1Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.86,121.39c2-.48-5.18-2.88-3.77-.66C414.54,121.45,417.19,121.56,417.86,121.39Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.1,140.61l1.43.33c.37,0-.47-.49-.36-.56-.43.27,2.53-.75,1.85-1,.05,0-5.8-3.48-5.88-2.27.09-1.35.59,2.18.39,1.53-1.08-3.57-8.38-7.48-12.47-8.36-2.27-.49-6.14-.41-7.52.23.11-.06.93,1.75-.19,2.44-.52.32-3-1.86-2.42-2.13s1.31.95,1.46-.21c.11-.94-4.79.38-5.5.48a27.06,27.06,0,0,1-3.56-.27c-1.55-.15-.72,1.22-1.36,1.53.55-.26-2-2.46-2-2.44-2.23-1.89-1.91-2.24-6.06-2.56-1.27-.1-7.48,0-8.11-1.89-.18-.56,1.89.11,1.34-.81-1.22-2-6.17.29-6.23.5a8.78,8.78,0,0,0,1-.68,5.87,5.87,0,0,0-1.43-.48c-.43-.7,2,0,2-.37.36-2.14-10.33-.88-9.28.58a1.11,1.11,0,0,0,1,0c-.68-.38.12,2.59.05,1.69,0,.17-2.43-.28-2.83,0a2.11,2.11,0,0,0,.73.48s-6.75-1.28-7.21-1.39-1.23,2.82-2.25,2.76c-1.52-.09-2.68-3.71-3.45-3.66a2.7,2.7,0,0,0,1.37.27c1.93-1.13-4.81-5.13-6.25-4.83-1.05.22-1.27,2.47-1.65,2.53-.57.1-6-.13-6.15-.76-.1-.34.73-.76.38-.85-2.8-.73-5,.58-6.74.75-.46,0,.09-1.63-.59-1.75-.33-.06-4.89,0-4.48.51.25.09.51.16.77.23.07.6-5.71,1.52-5.83,1.84,1.24-3.19,10.59-4,9.83-7.37-.23-1,.39-1.83-1.68-2.82-2.64-1.24-4.63.74-7,.15a6.52,6.52,0,0,1,.92-1.3c0,.26-3.31-.64-3.72-.47.28-.12,2.28-.45,1.84-1.14-1.51-2.3-5,.63-6.26,1.55.65-.47-2.43,3.61-2.54,1.69a5.57,5.57,0,0,0,.83.71c.14-.44-3.54.38-3.73.31.11-.27.23-.53.36-.79a25.67,25.67,0,0,0-4.12.79,1.35,1.35,0,0,0,.78.58c-.06-.47-6.16,1.62-6.61,1.83-1.44.67-.7.61-1.32,1.44-.36,0-.73,0-1.09-.07-.13.14,1.25.79,1.26.91a6.11,6.11,0,0,1-1,.07s1.52.9.83,1.53c-.41.37-2.78.17-3.46.31-9.48,2,0,2.64-1.84,5.15-.73,1-5.47-3.13-6.86-1.75-.12.12,1.53,1.27,1.16,1.37-.72.2-1.82-.85-2.34.15-.41.8,3.35,2.07,3.06,2.42,0,0-4-.83-4-.89-.79-.9,1.36-3.47-.32-4s-2.67,7.55-2,8.47c1.81,2.46,5.19,1.16,6.33,4.91.6,2-3.47-2.78-1.7-2-1.21-.52-.82-1.57-2.42-1.29-2.28.39-.11,1.69-1,2.77-1,1.27-2.35,3.11-3.74,3.42-.38.09-3.79-.09-3.48-1-.05.12,4.5-.46,5.26-3,.48-1.61-.32-2.9-.67-4.74-.1-.53.15-6.08.19-6-2.69-4.43-7.17.62-7.4,3.76.06-.87-.1,3.26-.3,2.74,0,0,4.86,3.12,2,3.58-2,.34-10-6.72-12.47-5.31.65-.37,4.34,6.34.78,4.9-1.4-.57.05-.7-3.17-.41,0,0-5.15.86-4.75.54s1.11-.65,1-1.45c0,.51-6.73,2.71-7.67,3.12-1.31.57-1,3-3.42,1.39s1.21-1.54,1.51-1.89c1.09-1.31-4.44-2.73-4.24-1.9,0-.23,1.3,4.15.26,3.39,2.59,1.87-.41,1.69-.58,1.82-3,2.4-3-.19-3.59,4.1-.1.72-2.48-.73-2.85-.44-.49-.31-1-.63-1.45-.95-.88.41-1,.94-.4,1.6,1.45-.82,1.92,3.15-.61,1.15-.62-.49-4.05-8-5.45-7.34,1-.48,15.2,6.28,10.85-1.51-.83-1.5-9.68-5.24-10.43-4.3a2,2,0,0,0,.94-.33c-.12-1-2.29,0-2.53-.23-.59-.65-2,.81-2.43-.79.08.31,2.3-.29,2.36-.6.47-2.59-4.08-.28-3.52-.26-.45,0,.24-1.4.2-1.47-.92-1.77-1.7,1.5-2.21,1.5-.18,0,.12-1.55-.2-1.34-.61.65-1.21,1.31-1.82,2-.66.13,1.29-2.14,1.28-2.19-.19-1.18-2.21,1.08-2.2,1.08.63-.54-2.54,1.8-1.61,1.52-1.22.37.32-2.75.47-2.17.08.27-1.85.22-1.82.68a1.91,1.91,0,0,1,.53,1,4.11,4.11,0,0,0-1.44-.05,1.68,1.68,0,0,0,.72.7,5.38,5.38,0,0,1-1.69-.58c.08,0,.54,1.73,0,1.4-.94-.62-.74-1.62-2-1.05-.1,0-2.74,2-2.69,2.3s1.29-.26,1.09.79c0,0-2.23,0-2.15.1.09-.39.19-.77.31-1.16a48,48,0,0,1-3.8,3.37c1,0,3.23-2.46,4.29-1.48,0,0-.16,1.08-.18,1.09-3,1.2-3.84,6.07-6.61,7.28-.24.11,1.13,1,.67,1.2-1.58.61-1.59,1.22-2.9,2.3-.1.08-1-1.15-1.06-.38-.15,1.58-.93.36-1.72,1.54a1.09,1.09,0,0,0,.68.56c-.84-1.86-3,3-2.92,2.62-.48,2.94,1.44,2,1.59,2.47.43,1.51-1.75.8-1.65.72a8.65,8.65,0,0,0-.22,1.32c0,.55,1.17-.6,1.39,0,.15.4-.73.82-.85,1-1.48,2.26,5,.51,4.23.68,1-.23,1.59-1.88,2.19-2.23.36-.22,3.16,8.52,3.44,8.62,1.32.5,4.07-3.51,4.51-3.64-.18.46-.41.57-.7.33.26-2.35,3.07-4.21,3-6,0-2.34-2.65-1.23-1.79-4.67.49-2,2-2.17,3-3.58.81-1.15,2.14-4.47,3.67-5,7.11-2.35-1.65,5.94-1.87,6.36-.55,1-.15,5.06.34,5.55,2,2,5.75.52,7.92-.07a6.82,6.82,0,0,1,.61-.85,6.16,6.16,0,0,0-.61.85,5,5,0,0,1,2.46,1c.48.56-6.1,1.28-5.81,1.14-4.22,2-.15,1.94-1.21,3.16-1.26,2-1.52.48-2,.91-.17.15-3.3.38-2.14,2.72,1.13,2.54-1.11,3.16-2.52,3.67.12,0-3.68.37-4.59.49-2,.24-.94.52-1.9-.86-.41-.58-2.73,1.6-3.16,1.28a1.8,1.8,0,0,1,0-.95c-.55-.15-2.22,0-2-1.45,0-.26,1.45.77,1.57.13.22-1.21-.69-.41-1-1-.17-.27,1.56-3.19.66-4.18-.61-.67-1.62,1.61-1.62,1.61-.65.65-1.28-.51-1.38,2.2,0,.87,1.67,2.85,1.24,3.7-.32.65-3.95,1.32-4.63,1.76a32.79,32.79,0,0,0-3.41,3.41,17.83,17.83,0,0,1-2.31,2.3c-1,.47-3.18.2-3.51.39-.75.42.69,1.56,0,2.13s-2.67-1.2-3.13-.33c-1.26,2.33.62.56,1.73,2.33,1.52,2.43,3.88,5.33.35,7.12-1.64.84-5.66-1.32-7-.6-2.51,1.37-.55,1.25-1.09,3.58-1.1,4.75-1,6.74,2.91,8,2.73.89,5.62.33,7.89-2.71,1.8-2.42,2.88-6.62,5.63-8.33-.62.39,5.75-.72,5.22-.74,2.73.14,1-.25,3.36,1.56-.07-.06,9,8.26,6.44,8.26,1.45,0,1-3.67,1.1-3.76a1.8,1.8,0,0,1,1.63.55c-1-.3-10-10-5.6-9.76.6,0,5.33,5.38,6.84,6.23a2,2,0,0,1,.09-.35,2,2,0,0,0-.09.35c-1.48-.87,3.95,8.27,3.95,6.14,0-1.88-2.45,4.66.75,2.9a4.24,4.24,0,0,0-.22-1.41,1.65,1.65,0,0,0,.88,0c.47-.58-1-.5-.68-.8s1.83.56,1.61-.66c-.26-1.48-1.06,0-1.61-.59.18.2-.23-3-.49-2.84a9,9,0,0,0,1.55.3c.85-.38,5.39-.35,6.49-1.45-.29.29-1.82-2.43-1.72-3a18.09,18.09,0,0,1,2.18-3.43c.52-.74.76-2.44,1.84-2.94.68-.32,3.72-.2,3.89.72a6.75,6.75,0,0,1-1.7,1c-.06-.32,1.38,1.76,1.34,1.72s3.91-1,4-1.12c.23-.4-3.56-.18-1.74-2.13.43-.45,4.69-2,5-1.39.07.15-3,3-2.89,3.54.4,1.91,6.25,2.95,6.06,5-.26,2.82-3.62,1.83-5.59,1.79-.84,0-1.51-.95-2.33-1-2.69-.17-4.27.45-6.81,1.16-3.26.91-6.87,2.6-3.09,6.45,1.77,1.81,3.5,1,5.5,1.08.66,0,4.68-.87,5.22-.52s-1.17,5.11-1.38,5.62l.67.31h0c0,.13,0,.28-.05.41,0-.13,0-.28.05-.41l-.65-.3c-2,4.69-5.8,3.73-10.75,2.8-1.31-.24-2.37-.87-3.68-1.05-2.12-.29-1-2-3.82-.55-.93.49-.67,2.37-.77,2.41-1.67.66-8.87-1.79-10.73-3.7s1.29-3.54-.12-5.53c-.86-1.21-6.72-.12-8.38.06a33,33,0,0,0-6,1.58c-2.05.58-3.71.41-5.62.91-1.62.43-1-.25-2.39.51,1.5-.8-3.23,3.52-2.65,2.59-.72,1.15-1.28,2.42-2,3.58-.52.9-.38,2.08-1.24,3.37-.56.85-1.7,1-2.33,1.64a22.61,22.61,0,0,0-4.15,6.65c-1.1,2.79-.45,3.24-.54,5.68-.09,2.27-.8,4.69-.73,6.93.08,2.46,1.19,3.45,2.39,5.39,2.7,4.39,5.9,8.45,11.08,9a23.43,23.43,0,0,0,8.11-1.13c.34-.09,3.81-2,4.17-1.57a32.66,32.66,0,0,0,2.94,1.58c.46.22.28,1.33.87,1.6s1.25-.63,1.74-.32c2.75,1.73,1.69.23,3.09,3.4.27.7-.54,2.94-.53,3.29.06,2.85,1.13,3.27,2.79,6.16,1.37,2.37,3.11,7,2.74,9.75-.4,2.91-2.53,5.43-2.66,8.62-.22,2.14,2.83,7.18,3.3,9.42.85,4,2.08,6.45,3.42,10.25,1.82,5.17.26,6.29,6,5.57,5.58-.68,8.75-2.43,11.67-8a27.72,27.72,0,0,0,1-4.45c2-2.88,3.18-1.31,3.73-5.07.39-2.67-1.28-2.66.17-5.22,1.16-2.06,4.35-2.37,5.59-4.22,2.56-3.85-.1-8.1-.83-12-.79-4.17,1.34-7.18,4.21-10.28,1.18-1.29,15.31-16.18,10.92-17.8-3-1.13-6.39,3.2-9.85,1l0,0a0,0,0,0,0,0,0,27.49,27.49,0,0,0-2.69-4.77c-1.59-1.93-3.8-3.85-4.73-6.46-.4-1.12-6.12-16.82-6.32-16.75.34-.12,1.25,3.64,2.14,3.64a6.23,6.23,0,0,0,.77-2c.87.52,3.55,6.58,4.11,7.73,1.57,3.24,3.6,6.09,5.15,9.46.72,1.55.56,5,1.64,6.16,1.45,1.59,4.57,0,6.76-.95,3.92-1.71,8.48-4,11.13-6.76.28-.3,3.45-4,3.34-4.76s-5-6.39-4.34-6.33c-1.23-.11-2.77,3.6-5.21,3.38-2-.18,0-2.63-1.17-3-.53-.16-.92,1.4-.94,1.38-1.14-.85-4-6.81-2.49-7.62.89-.49,6.27,4.48,8.11,5.31.38.17,2.27.06,2.75.21.21.06.94,1.18,1.72,1.43,2.21.71,4.52.36,6.74.43s2.86,0,4.64.91c-.27-.13,4.15,4.06,4.15,2.89a3.09,3.09,0,0,1-1.77.67c-.94,4.63,5.58.82,4.45.25,1,.52,6.17,33,9.77,13.94,1-5.32,2.77-6.34,6.8-10.34.73-.73,5.51-5.12,6.65-4.5,2.59,1.43,2.25,8.57,3.61,9.71,2.85,2.38,2.2-5.27,4.15,3,.65,2.7-.06,5.88.56,8.28.36,1.39,5.09,11.15,7.4,10,1.66-.85-2.86-6.8-3.62-7.79-1-1.27-5.05-8.17-1.36-9.42,1.09-.37,3.55,2.87,4,3.37.16.19,2,3.43,1.89,3.34.23.15,2.83-2.34,3-2.47,3.94-3.75,2.44-4.73.17-9.05-1.13-2.17-3.36-5.31.5-6.82,2.69-1,1.76.27,2.95,1.51-.24-.24,10.42-5.53,11.51-6.87.69-.84,3.81-7.77,4.18-7.66-.35-.1-1.41,0-1.73-.23.62.44,2-2.7-.55-2.7.05,0,2.19-.16,1.85.21.2-.22-3.26-4.92-3.24-5.07.31-2.13,2.84-2.17,4.13-3.16,2-1.55-5.26-1-3.68-.23a29.15,29.15,0,0,1-2.63-2.44c0-.46,5.18-4,5.74-3.5.13.12-1.33,3.3-1,3.31,4.08.24,1.9-2.44,5.18-.32-1.52-1,.53,2.55.23,1.94,0,0,1.5.32,1.78,1.2.21.69-1.13,3-.46,4,.28.43,3.81-1.36,3.91-1.52,1.14-1.79-1.13-3.3-1.37-4.91-.49-3.39-.86-.05.39-3.11a15.14,15.14,0,0,1,3.25-4.24h0c1.58-1.26,1.8.55,3.53-.18s3-2.8,4-4.1a21.41,21.41,0,0,0,4.46-9c.47-1.88,1.66-4.14.64-5.76-2-3.16-2.37-.26-4.26-.14-.22,0,0-1.54,0-1.64s-1.08,1-1,1c1.2-.27-2-2.62-2.11-1.87.19-1.15,3.53-3.36,4.41-4.18,2.79-2.61,4.21-4.6,8-5.15,1-.13,9.39.07,9.1.56a3,3,0,0,1-.93.3c-.5.4,5.29-.39,5-.69-1.83-2,4.39-6.87,6.67-5.31-.29-.2-.19,2.54-.25,2.42.25.55,6.63-5.06,6.5-3.74-.2,1.93-5.58,6.41-7.4,8-2.38,2.06-3.54,1.77-4.58,5-.66,2.06-.46,8.55,1.13,10.29-.25-.27,8.3-10.17,8.37-10.24-.8.79-.19-3.68,0-3-.48-1.44-2.05-1.18.17-3.84a15.06,15.06,0,0,1,3.39-1.93,1.3,1.3,0,0,1,.26,1.22c-.52-2.12,5.53-.18,5.32-.13,1.06-.28,2.61-2.32,3.87-3.06s6.05-1.91,6.45-2.29c3.21-3.06-1.78-2.87-2.47-5.15.27.88,4.58-.82,5.2-1.19.91-.53-.32-1.44,1.27-2.31-.9.5,6.52,5.83,7.92,4.47a1.66,1.66,0,0,0-.56-.77C474.17,142.63,475.33,140.8,475.1,140.61Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,98.93c1.15-1.62-5-.73-3.62.49C312.57,100,315,99.67,315.53,98.93Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.08,99.71c-.58.25-1.16.46-1.75.66-.77.86,3.9.72,4.2-.28C311.72,99.48,309,99.55,309.08,99.71Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.89,97.48a10,10,0,0,0,2.34-.91c-.49-.67-3.93.64-4,.41A2,2,0,0,0,308.89,97.48Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,170.3c.8,2-1.59,7.71-.34,9.31-.85-1.09,1.9.11,1.92.12s-1.1-3.29-1-3.43c1-2.23,2-1.19,2.34-1.63.6-.81-2.93-9.8-2.43-10.12C415.2,165.46,415.7,169.26,416.13,170.3Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.57,121.73a3.16,3.16,0,0,0,2-.5C328.35,119.66,323.87,121.44,325.57,121.73Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.57,121.89c-.08-.66-1.46.19-1,.46S337.64,122.55,337.57,121.89Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.29,98.72l1.14-.6c.37-1.27-3.4.3-3.26.48A3,3,0,0,0,318.29,98.72Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.08,279c.08.5,3.25,3.15,3.7,2.82S444,278.53,444.08,279Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.3,213.28c-.71-1.34.16,2.65.48,1.91A13.83,13.83,0,0,1,135.3,213.28Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.17,235.21c.94.21,1.25-.11.91-.94C156.41,233.65,155.86,234.9,156.17,235.21Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.2,253.71c0-.37-1-.19-.67.33S372.2,254.08,372.2,253.71Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,261.69a3.21,3.21,0,0,0,1.51.05c.67-.56-3.63-1.3-3.51-1.24a1.15,1.15,0,0,1,1.28-1c-1.12.75-10.91-2.54-10.26-.22C369.27,260.26,379.56,262.35,380,261.69Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.6,261.74c1,0,1.11-.13.41-.42-.5-.08-5.18.42-5.09.62C387.53,263.27,390.75,261.79,391.6,261.74Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,261.24c-.36.89-1.24-.31-1.7.3-.94,1.26,3.23,1.23,3.59.36C386.11,261.4,384.18,260.83,384,261.24Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.92,248.75c2.85,2.91,1.46,5.42,6.16,5.67,3.91.2,4.13-2.91,6.67-6.09-.17.21-1.68-3.36-1.66-3.69.08-1.52,1.88-1.3,2.19-2.31s-3.63-1.73-3.84-1.68c-1.27.28-.63,2.52-2.81,2.35-.07,0-3.83,4.31-3.84,4.34C376.07,246.67,370.94,246.72,372.92,248.75Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,247.63c-.08.41.34,1.61.79,1.12S358.09,247.22,358,247.63Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.87,251.19c-.08.2.34,1,.6.78S360.1,250.53,359.87,251.19Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.26,255.78c-.11-1.74.87-1.28.86-2.4,0-.49-1.59-2-1.62-1.07a5.42,5.42,0,0,1,.8,1c-.33.83-4.2-5.07-4.4-5.29-.9-1-8.72-7-9.07-6.22-.25.58,6,9.58,6.83,10.72S369.62,261.3,369.26,255.78Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.24,264c0-1.12-2.23-.52-2.34-.7S388.24,265,388.24,264Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.71,253.3c-.18.33,2.38,4.07,1.32,4.51,1-.41.11-4.56,1.09-4.08,1.86.91-.2,3.48,2.29,1.54-1.32,1,.07-6.84,1.08-4.62.13.3-5.63,1.81-4.19-.54,1.57-2.57,5.07.37,6.45-2.48-.83,1.72-4.26-.38-5.4.39C386.57,249.22,386.7,251.54,385.71,253.3Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,254.25a18.53,18.53,0,0,0,3.36.91C402.36,255.16,396.92,252,397.6,254.25Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.79,247.75c0-2.78-2.31,2.95-.19,2.53C399,250,397.79,247.7,397.79,247.75Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,263.26c.65-.86,2.83-1,3.12-1.81.16-.48-3.35,1.07-3.68,1.11-.51.08-2,1.17-1,1.7A1.73,1.73,0,0,0,393.54,263.26Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,254.33c.16.66,1.25,1,1.55.46S394.82,253.56,395,254.33Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.18,188.3c-.35.65.44,4.37,1.89,2.54C249.26,189.33,247.09,186.58,246.18,188.3Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.4,192.74c.27-.06-2.9-.28-2.62.56a9.5,9.5,0,0,0,2.78,1.78,19.89,19.89,0,0,1,.86-2.25A.8.8,0,0,0,254.4,192.74Z",
    style: {
      fill: "none",
      stroke: "gray",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-48"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 456.04,
    x2: 465.14,
    y2: 456.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,420.9s-26.49-46.52-20.38-58.35S74.36,372,74.36,372s-13.59-43.37-6.11-62.3,20.37,0,21,13.41-2.71,36.27-2.71,36.27,5.43-47.31,18.33-33.12-16.3,61.51-16.3,61.51,19.7-11,19,3.16-23.77,26.81-23.77,26.81",
    style: {
      fill: "#3B61E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.23,412.23s-24.52-22.87-12.58-33.12,18.23,11,18.23,11-13.2-65.45,8.18-67.82,5.65,56.78,5.65,56.78,18.23-25.24,17-4.73S81.4,412.23,81.4,412.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.27,
    y1: 408.06,
    x2: 68.7,
    y2: 390.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.82,
    y1: 409.45,
    x2: 86.3,
    y2: 356.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.12,
    y1: 405.65,
    x2: 95.97,
    y2: 385.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.59 401.99 56.77 401.99 61.35 456.04 98.01 456.04 102.59 401.99",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-balloons--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398,127.78,346.16,131a11.44,11.44,0,0,0-10.73,11.57l.26,20.83L320.62,165l15.19,7.84a11.44,11.44,0,0,0,11.65,11.28l50.33-.92a11.44,11.44,0,0,0,11.22-11l1.16-32.56A11.43,11.43,0,0,0,398,127.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.55,
    y: 133.16,
    width: 33.95,
    height: 21.38,
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.22,
    y: 133.16,
    width: 19.28,
    height: 21.38,
    style: {
      fill: "#696969",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.61,
    y: 133.16,
    width: 13.83,
    height: 21.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,171.84v-5.43c0-2.61,1.85-4.35,4.64-4.35s4.64,1.7,4.64,4.27c0,.12-.1.2-.25.22l-.89.06c-.16,0-.26,0-.26-.12v-.12a3.24,3.24,0,0,0-6.48,0v5.53a3.24,3.24,0,0,0,6.48,0,.21.21,0,0,1,.26-.22l.89,0c.15,0,.25,0,.25.1v.1c0,2.59-1.85,4.31-4.64,4.31S353.3,174.47,353.3,171.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.23,163.23a1.07,1.07,0,1,1,1.07,1A1,1,0,0,1,365.23,163.23Zm.38,12.56v-9.48a.24.24,0,0,1,.25-.26h.89a.24.24,0,0,1,.26.26v9.48a.24.24,0,0,1-.26.26h-.89A.24.24,0,0,1,365.61,175.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48,169.21v6.58a.24.24,0,0,1-.25.26h-.89a.24.24,0,0,1-.26-.26v-.71c0-.08-.06-.12-.12,0a4.18,4.18,0,0,1-3.08,1.17c-1.68,0-3.26-.81-3.26-2.89s1.5-3.2,4.07-3.2H376a.09.09,0,0,0,.1-.1v-.73a2,2,0,0,0-2.31-2.17c-1.25,0-2.06.51-2.28,1.34a.23.23,0,0,1-.29.2l-1-.12c-.16,0-.26-.08-.24-.21.26-1.45,1.72-2.44,3.76-2.44C376.16,165.89,377.48,167.26,377.48,169.21Zm-1.4,3.64v-1.52a.09.09,0,0,0-.1-.1h-2.07c-1.72,0-2.89.73-2.89,2s1,1.75,2.17,1.75C374.66,175,376.08,174.23,376.08,172.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.35,173.46a8.54,8.54,0,0,1-.28-2.43,9,9,0,0,1,.26-2.41,4.1,4.1,0,0,1,7.72,0,8.73,8.73,0,0,1,.28,2.43,8.54,8.54,0,0,1-.28,2.43,4.07,4.07,0,0,1-7.7,0Zm6.4-.41a9.21,9.21,0,0,0,.16-2,8.39,8.39,0,0,0-.16-2,2.65,2.65,0,0,0-5.1,0,12.52,12.52,0,0,0,0,4,2.65,2.65,0,0,0,5.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,153.41l-20.5-5.54L165,117.48a9.66,9.66,0,0,0-10.33-11.08L111.14,110a9.64,9.64,0,0,0-8.83,10.39l3.2,39.86a9.65,9.65,0,0,0,9.24,8.87l33.5,1.32a9.63,9.63,0,0,0,9.92-8.18l.87-5.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.46,
    y: 114.9,
    width: 33.95,
    height: 21.38,
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.46,
    y: 120.08,
    width: 33.95,
    height: 11.03,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,144h.89a.24.24,0,0,1,.25.26v13.32a.24.24,0,0,1-.25.26h-.89a.24.24,0,0,1-.26-.26v-6a.09.09,0,0,0-.1-.1h-6.26a.09.09,0,0,0-.1.1v6a.24.24,0,0,1-.26.26h-.89a.23.23,0,0,1-.25-.26V144.22a.23.23,0,0,1,.25-.26h.89a.24.24,0,0,1,.26.26v5.91a.09.09,0,0,0,.1.1H124a.09.09,0,0,0,.1-.1v-5.91A.24.24,0,0,1,124.35,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.83,155.21a8.66,8.66,0,0,1-.27-2.43,9.09,9.09,0,0,1,.25-2.41,4.11,4.11,0,0,1,7.73,0,8.73,8.73,0,0,1,.28,2.43,8.63,8.63,0,0,1-.28,2.43,4.08,4.08,0,0,1-7.71,0Zm6.4-.42a9.05,9.05,0,0,0,.16-2,8.48,8.48,0,0,0-.16-2,2.64,2.64,0,0,0-5.09,0,8.7,8.7,0,0,0-.16,2,8.49,8.49,0,0,0,.16,2,2.64,2.64,0,0,0,5.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.66,157.54V144.22a.24.24,0,0,1,.26-.26h.89a.24.24,0,0,1,.25.26v13.32a.24.24,0,0,1-.25.26h-.89A.24.24,0,0,1,139.66,157.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.44,151v6.58a.24.24,0,0,1-.26.26h-.89a.24.24,0,0,1-.26-.26v-.71c0-.08-.06-.12-.12,0a4.16,4.16,0,0,1-3.08,1.16c-1.68,0-3.26-.81-3.26-2.88s1.5-3.2,4.07-3.2h2.29a.09.09,0,0,0,.1-.1V151a2,2,0,0,0-2.31-2.18c-1.24,0-2.05.52-2.27,1.35a.23.23,0,0,1-.3.19l-1-.11c-.15,0-.25-.08-.23-.22.25-1.44,1.72-2.43,3.75-2.43C150.11,147.64,151.44,149,151.44,151ZM150,154.59v-1.52a.09.09,0,0,0-.1-.1h-2.07c-1.72,0-2.89.73-2.89,2s1,1.76,2.18,1.76C148.61,156.75,150,156,150,154.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.29,205.67H387.62A20.33,20.33,0,0,0,367.29,226v7.51L354,233l13.33,8.7v5.63a20.34,20.34,0,0,0,20.33,20.34h26.67a20.34,20.34,0,0,0,20.33-20.34V226A20.33,20.33,0,0,0,414.29,205.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.45,243.6h.89a.24.24,0,0,1,.25.25v13.32a.24.24,0,0,1-.25.26h-.89a.24.24,0,0,1-.26-.26v-6a.09.09,0,0,0-.1-.1h-6.26a.09.09,0,0,0-.1.1v6a.24.24,0,0,1-.26.26h-.89a.24.24,0,0,1-.26-.26V243.85a.24.24,0,0,1,.26-.25h.89a.24.24,0,0,1,.26.25v5.91a.09.09,0,0,0,.1.1h6.26a.09.09,0,0,0,.1-.1v-5.91A.24.24,0,0,1,390.45,243.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,254.9a.23.23,0,0,1,.34-.12l.57.32c.14.08.2.2.12.33a3.86,3.86,0,0,1-3.67,2.16,3.65,3.65,0,0,1-3.7-2.47,7.68,7.68,0,0,1-.38-2.73,9.11,9.11,0,0,1,.18-2.29,3.74,3.74,0,0,1,3.82-2.83,3.69,3.69,0,0,1,3.95,3.4,10.37,10.37,0,0,1,.12,2,.23.23,0,0,1-.26.25h-6.32a.09.09,0,0,0-.1.1,6.32,6.32,0,0,0,.12,1.45,2.55,2.55,0,0,0,2.68,1.93A2.71,2.71,0,0,0,401.39,254.9Zm-5.17-4.55a5.58,5.58,0,0,0-.16,1.35.09.09,0,0,0,.1.1h5.08a.09.09,0,0,0,.09-.1,10.31,10.31,0,0,0-.11-1.27,2.47,2.47,0,0,0-2.55-1.93A2.34,2.34,0,0,0,396.22,250.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,257.17V243.85a.24.24,0,0,1,.26-.25h.89a.23.23,0,0,1,.25.25v13.32a.23.23,0,0,1-.25.26h-.89A.24.24,0,0,1,405.52,257.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.11,257.17V243.85a.24.24,0,0,1,.25-.25h.89a.24.24,0,0,1,.26.25v13.32a.24.24,0,0,1-.26.26h-.89A.24.24,0,0,1,410.11,257.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.65,254.84a8.54,8.54,0,0,1-.28-2.43,9,9,0,0,1,.26-2.41,4.11,4.11,0,0,1,7.73,0,8.76,8.76,0,0,1,.27,2.43,8.57,8.57,0,0,1-.27,2.43,4.08,4.08,0,0,1-7.71,0Zm6.4-.41a9.21,9.21,0,0,0,.16-2,8.53,8.53,0,0,0-.16-2,2.64,2.64,0,0,0-5.09,0,8.75,8.75,0,0,0-.16,2,8.64,8.64,0,0,0,.16,2,2.64,2.64,0,0,0,5.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.14,
    y: 214.54,
    width: 33.95,
    height: 21.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 214.54,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 217.78,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 221.01,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 224.25,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 227.49,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 230.73,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: 233.97,
    width: 33.95,
    height: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.14,
    y: 214.54,
    width: 16.46,
    height: 11.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.78 215.5 384.93 215.82 385.25 215.87 385.02 216.12 385.07 216.47 384.78 216.31 384.5 216.47 384.55 216.12 384.32 215.87 384.64 215.82 384.78 215.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.78 217.61 384.93 217.93 385.25 217.98 385.02 218.23 385.07 218.58 384.78 218.41 384.5 218.58 384.55 218.23 384.32 217.98 384.64 217.93 384.78 217.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.78 219.71 384.93 220.03 385.25 220.08 385.02 220.33 385.07 220.68 384.78 220.51 384.5 220.68 384.55 220.33 384.32 220.08 384.64 220.03 384.78 219.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.78 221.81 384.93 222.13 385.25 222.19 385.02 222.43 385.07 222.78 384.78 222.62 384.5 222.78 384.55 222.43 384.32 222.19 384.64 222.13 384.78 221.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.78 223.92 384.93 224.24 385.25 224.29 385.02 224.54 385.07 224.89 384.78 224.72 384.5 224.89 384.55 224.54 384.32 224.29 384.64 224.24 384.78 223.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.29 216.73 386.43 217.05 386.75 217.1 386.52 217.35 386.57 217.7 386.29 217.54 386 217.7 386.05 217.35 385.82 217.1 386.14 217.05 386.29 216.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.29 218.84 386.43 219.16 386.75 219.21 386.52 219.46 386.57 219.81 386.29 219.64 386 219.81 386.05 219.46 385.82 219.21 386.14 219.16 386.29 218.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.29 220.94 386.43 221.26 386.75 221.31 386.52 221.56 386.57 221.91 386.29 221.75 386 221.91 386.05 221.56 385.82 221.31 386.14 221.26 386.29 220.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.29 223.04 386.43 223.36 386.75 223.41 386.52 223.66 386.57 224.01 386.29 223.85 386 224.01 386.05 223.66 385.82 223.41 386.14 223.36 386.29 223.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.79 215.5 387.94 215.82 388.26 215.87 388.02 216.12 388.08 216.47 387.79 216.31 387.5 216.47 387.56 216.12 387.32 215.87 387.65 215.82 387.79 215.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.79 217.61 387.94 217.93 388.26 217.98 388.02 218.23 388.08 218.58 387.79 218.41 387.5 218.58 387.56 218.23 387.32 217.98 387.65 217.93 387.79 217.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.79 219.71 387.94 220.03 388.26 220.08 388.02 220.33 388.08 220.68 387.79 220.51 387.5 220.68 387.56 220.33 387.32 220.08 387.65 220.03 387.79 219.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.79 221.81 387.94 222.13 388.26 222.19 388.02 222.43 388.08 222.78 387.79 222.62 387.5 222.78 387.56 222.43 387.32 222.19 387.65 222.13 387.79 221.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.79 223.92 387.94 224.24 388.26 224.29 388.02 224.54 388.08 224.89 387.79 224.72 387.5 224.89 387.56 224.54 387.32 224.29 387.65 224.24 387.79 223.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.3 216.73 389.44 217.05 389.76 217.1 389.53 217.35 389.58 217.7 389.3 217.54 389.01 217.7 389.06 217.35 388.83 217.1 389.15 217.05 389.3 216.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.3 218.84 389.44 219.16 389.76 219.21 389.53 219.46 389.58 219.81 389.3 219.64 389.01 219.81 389.06 219.46 388.83 219.21 389.15 219.16 389.3 218.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.3 220.94 389.44 221.26 389.76 221.31 389.53 221.56 389.58 221.91 389.3 221.75 389.01 221.91 389.06 221.56 388.83 221.31 389.15 221.26 389.3 220.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.3 223.04 389.44 223.36 389.76 223.41 389.53 223.66 389.58 224.01 389.3 223.85 389.01 224.01 389.06 223.66 388.83 223.41 389.15 223.36 389.3 223.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.8 215.5 390.94 215.82 391.26 215.87 391.03 216.12 391.09 216.47 390.8 216.31 390.51 216.47 390.56 216.12 390.33 215.87 390.65 215.82 390.8 215.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.8 217.61 390.94 217.93 391.26 217.98 391.03 218.23 391.09 218.58 390.8 218.41 390.51 218.58 390.56 218.23 390.33 217.98 390.65 217.93 390.8 217.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.8 219.71 390.94 220.03 391.26 220.08 391.03 220.33 391.09 220.68 390.8 220.51 390.51 220.68 390.56 220.33 390.33 220.08 390.65 220.03 390.8 219.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.8 221.81 390.94 222.13 391.26 222.19 391.03 222.43 391.09 222.78 390.8 222.62 390.51 222.78 390.56 222.43 390.33 222.19 390.65 222.13 390.8 221.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.8 223.92 390.94 224.24 391.26 224.29 391.03 224.54 391.09 224.89 390.8 224.72 390.51 224.89 390.56 224.54 390.33 224.29 390.65 224.24 390.8 223.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.3 216.73 392.45 217.05 392.77 217.1 392.54 217.35 392.59 217.7 392.3 217.54 392.01 217.7 392.07 217.35 391.84 217.1 392.16 217.05 392.3 216.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.3 218.84 392.45 219.16 392.77 219.21 392.54 219.46 392.59 219.81 392.3 219.64 392.01 219.81 392.07 219.46 391.84 219.21 392.16 219.16 392.3 218.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.3 220.94 392.45 221.26 392.77 221.31 392.54 221.56 392.59 221.91 392.3 221.75 392.01 221.91 392.07 221.56 391.84 221.31 392.16 221.26 392.3 220.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.3 223.04 392.45 223.36 392.77 223.41 392.54 223.66 392.59 224.01 392.3 223.85 392.01 224.01 392.07 223.66 391.84 223.41 392.16 223.36 392.3 223.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 215.5 393.95 215.82 394.27 215.87 394.04 216.12 394.09 216.47 393.81 216.31 393.52 216.47 393.57 216.12 393.34 215.87 393.66 215.82 393.81 215.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 217.61 393.95 217.93 394.27 217.98 394.04 218.23 394.09 218.58 393.81 218.41 393.52 218.58 393.57 218.23 393.34 217.98 393.66 217.93 393.81 217.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 219.71 393.95 220.03 394.27 220.08 394.04 220.33 394.09 220.68 393.81 220.51 393.52 220.68 393.57 220.33 393.34 220.08 393.66 220.03 393.81 219.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 221.81 393.95 222.13 394.27 222.19 394.04 222.43 394.09 222.78 393.81 222.62 393.52 222.78 393.57 222.43 393.34 222.19 393.66 222.13 393.81 221.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.81 223.92 393.95 224.24 394.27 224.29 394.04 224.54 394.09 224.89 393.81 224.72 393.52 224.89 393.57 224.54 393.34 224.29 393.66 224.24 393.81 223.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.31 216.73 395.45 217.05 395.78 217.1 395.54 217.35 395.6 217.7 395.31 217.54 395.02 217.7 395.08 217.35 394.84 217.1 395.17 217.05 395.31 216.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.31 218.84 395.45 219.16 395.78 219.21 395.54 219.46 395.6 219.81 395.31 219.64 395.02 219.81 395.08 219.46 394.84 219.21 395.17 219.16 395.31 218.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.31 220.94 395.45 221.26 395.78 221.31 395.54 221.56 395.6 221.91 395.31 221.75 395.02 221.91 395.08 221.56 394.84 221.31 395.17 221.26 395.31 220.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.31 223.04 395.45 223.36 395.78 223.41 395.54 223.66 395.6 224.01 395.31 223.85 395.02 224.01 395.08 223.66 394.84 223.41 395.17 223.36 395.31 223.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 215.5 396.96 215.82 397.28 215.87 397.05 216.12 397.1 216.47 396.81 216.31 396.53 216.47 396.58 216.12 396.35 215.87 396.67 215.82 396.81 215.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 217.61 396.96 217.93 397.28 217.98 397.05 218.23 397.1 218.58 396.81 218.41 396.53 218.58 396.58 218.23 396.35 217.98 396.67 217.93 396.81 217.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 219.71 396.96 220.03 397.28 220.08 397.05 220.33 397.1 220.68 396.81 220.51 396.53 220.68 396.58 220.33 396.35 220.08 396.67 220.03 396.81 219.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 221.81 396.96 222.13 397.28 222.19 397.05 222.43 397.1 222.78 396.81 222.62 396.53 222.78 396.58 222.43 396.35 222.19 396.67 222.13 396.81 221.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 223.92 396.96 224.24 397.28 224.29 397.05 224.54 397.1 224.89 396.81 224.72 396.53 224.89 396.58 224.54 396.35 224.29 396.67 224.24 396.81 223.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.32 216.73 398.46 217.05 398.78 217.1 398.55 217.35 398.61 217.7 398.32 217.54 398.03 217.7 398.08 217.35 397.85 217.1 398.17 217.05 398.32 216.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.32 218.84 398.46 219.16 398.78 219.21 398.55 219.46 398.61 219.81 398.32 219.64 398.03 219.81 398.08 219.46 397.85 219.21 398.17 219.16 398.32 218.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.32 220.94 398.46 221.26 398.78 221.31 398.55 221.56 398.61 221.91 398.32 221.75 398.03 221.91 398.08 221.56 397.85 221.31 398.17 221.26 398.32 220.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.32 223.04 398.46 223.36 398.78 223.41 398.55 223.66 398.61 224.01 398.32 223.85 398.03 224.01 398.08 223.66 397.85 223.41 398.17 223.36 398.32 223.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.82 215.5 399.97 215.82 400.29 215.87 400.06 216.12 400.11 216.47 399.82 216.31 399.53 216.47 399.59 216.12 399.36 215.87 399.68 215.82 399.82 215.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.82 217.61 399.97 217.93 400.29 217.98 400.06 218.23 400.11 218.58 399.82 218.41 399.53 218.58 399.59 218.23 399.36 217.98 399.68 217.93 399.82 217.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.82 219.71 399.97 220.03 400.29 220.08 400.06 220.33 400.11 220.68 399.82 220.51 399.53 220.68 399.59 220.33 399.36 220.08 399.68 220.03 399.82 219.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.82 221.81 399.97 222.13 400.29 222.19 400.06 222.43 400.11 222.78 399.82 222.62 399.53 222.78 399.59 222.43 399.36 222.19 399.68 222.13 399.82 221.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.82 223.92 399.97 224.24 400.29 224.29 400.06 224.54 400.11 224.89 399.82 224.72 399.53 224.89 399.59 224.54 399.36 224.29 399.68 224.24 399.82 223.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9,236.59H145.37A34.29,34.29,0,1,0,147,246.92c0-.26,0-.51,0-.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.09,258.35A24.74,24.74,0,0,1,94,261.44a9.94,9.94,0,0,0-.85-1.07,29.61,29.61,0,0,0,4.76-9.62l1.64.49c-.08.2-.25.24-.47.22a43.11,43.11,0,0,1-1.88,4.68l.57.16c0,.12-.13.22-.39.23V269.1H96.09Zm13.53.48c.16-.73.36-1.84.53-2.91h-3.93v11.54c0,1.42-.51,1.68-3.28,1.68a5.31,5.31,0,0,0-.49-1.36c.49,0,1,0,1.34,0h.79c.26,0,.34-.08.34-.34V255.92h-3.18a17.44,17.44,0,0,1-2,3.74,5.36,5.36,0,0,0-1-.81A21.39,21.39,0,0,0,102,250.8l1.64.44c0,.14-.17.22-.43.2a30.77,30.77,0,0,1-1,3.24h8.73l.7,0a34.49,34.49,0,0,1-.89,4.34Zm-6.32.65c-.06.14-.2.22-.44.22a19.4,19.4,0,0,1-3,6.6,6.3,6.3,0,0,0-1.05-.68A17.94,17.94,0,0,0,101.7,259Zm7.17,6.66a27.38,27.38,0,0,0-2.71-6.82l1.17-.41a26.42,26.42,0,0,1,2.81,6.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,254.88l.75.19-.12.28a25.84,25.84,0,0,1-1.9,8.5A13.92,13.92,0,0,1,121,266l-.81,1.09a13.41,13.41,0,0,0-2.11-2.06,10.69,10.69,0,0,1-3.91,4.13,6.16,6.16,0,0,0-.83-1.09,9.34,9.34,0,0,0,3.71-3.85,26.14,26.14,0,0,0-2.25-1.52l-.24.87-1.13-.59c.5-1.74,1.11-4.25,1.68-6.8h-2v-1.25h2.25c.32-1.48.59-2.9.83-4.17l1.62.2c0,.14-.14.22-.39.24-.22,1.13-.5,2.41-.79,3.73h3Zm-3.56,1.3c-.42,1.84-.87,3.69-1.29,5.31.83.46,1.68,1,2.51,1.57a23.24,23.24,0,0,0,1.64-6.88Zm15.08,3.4v1.28h-4.77v6.54c0,1.52-.59,1.76-4.09,1.72a6.71,6.71,0,0,0-.49-1.32l2.37,0c.67,0,.87,0,.87-.42v-6.56h-4.84v-1.28h4.84v-3.36l.65,0a20,20,0,0,0,2.93-3.22H121.3v-1.25h8.61l.26-.08,1.05.66a.64.64,0,0,1-.32.19,24.82,24.82,0,0,1-4.23,4.57v2.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8,
    y: 223.2,
    width: 33.95,
    height: 21.38,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.81 224.46 100.64 226.13 102.47 226.39 101.14 227.69 101.46 229.51 99.81 228.65 98.17 229.51 98.49 227.69 97.16 226.39 98.99 226.13 99.81 224.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.14 223.81 105.57 224.67 106.51 224.81 105.83 225.47 105.99 226.41 105.14 225.97 104.3 226.41 104.46 225.47 103.77 224.81 104.72 224.67 105.14 223.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.29 228.15 106.71 229.01 107.66 229.14 106.97 229.81 107.13 230.75 106.29 230.31 105.44 230.75 105.6 229.81 104.92 229.14 105.86 229.01 106.29 228.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.47 230.99 103.89 231.84 104.84 231.98 104.16 232.65 104.32 233.59 103.47 233.14 102.63 233.59 102.79 232.65 102.1 231.98 103.05 231.84 103.47 230.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.56 232.29 99.98 233.14 100.93 233.28 100.25 233.95 100.41 234.89 99.56 234.45 98.72 234.89 98.88 233.95 98.19 233.28 99.14 233.14 99.56 232.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.48,155.48A41.48,41.48,0,0,0,262,114H247.56a41.48,41.48,0,0,0-41.48,41.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.48,
    y1: 186.2,
    x2: 303.48,
    y2: 155.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.08,
    y1: 155.48,
    x2: 206.08,
    y2: 186.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,232.29s2.59,18.09,2.07,22.74-1.55,9.3-14.47,4.13-36.17,4.14-51.16,22.22-43.4,78.55-43.4,85.78,5.68,17,16,18.6,34.62-27.9,34.62-27.9,10.33,58.39,10.33,63S185.23,456,185.23,456H331.47l-5.69-37.72,10.34-83.2s42.89,58.39,52.19,61,23.77-2.07,27.39-12.92-2.07-22.22-9.31-30.49-52.7-81.13-61-87.84-31.52-7.24-39.79-5.17-22.22,5.17-25.84,3.1-3.61-21.7,0-30.49C279.79,232.29,248.27,240.56,235.87,232.29Z",
    style: {
      fill: "#3B61E1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,389.63a52.36,52.36,0,0,0,5.09,1.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,356.48s2.3,20.08,21.22,30.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.85,
    y1: 297.67,
    x2: 257.91,
    y2: 312.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.33,
    y1: 311.72,
    x2: 349.99,
    y2: 306.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "343.02 304.63 336.12 335.12 344.6 317.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,359.57s10.92-7,21.67-7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.78,380.54a149,149,0,0,0,19.79-12.82,44.28,44.28,0,0,1,31.5-8.92c10.31,1.11,15.89,13.93,16.16,26.76s-6.69,20.62-19.23,22.57-27.32-.83-36.51-3.06a121.13,121.13,0,0,0-14.78-2.79S336.73,383.88,351.78,380.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,385.56c-.27-12.83-5.85-25.65-16.16-26.76a44.28,44.28,0,0,0-31.5,8.92l-1.4,1.07c12,.41,36.26,5.31,32.46,38.82C413.51,405,419.49,397.45,419.23,385.56Z",
    style: {
      fill: "#3B61E1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,232.29s2.59,18.09,2.07,22.74c-.39,3.49-1.07,7-6.83,6.32,8.24,13.47,32.17,45.09,54.5,2-2.6.16-4.7,0-5.82-.62-3.61-2.07-3.61-21.7,0-30.49C279.79,232.29,248.27,240.56,235.87,232.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.87,232.29s.67,4.7,1.26,9.92a45.79,45.79,0,0,0,19.4,5.28,37.46,37.46,0,0,0,21.11-6.11,37.39,37.39,0,0,1,2.15-9.09S248.27,240.56,235.87,232.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.28,
    y: 169.75,
    width: 15.53,
    height: 36.94,
    rx: 6.34,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.63,169.78c-.23,0-.47,0-.71,0h-1.76c-.24,0-.47,0-.71,0v36.88c.24,0,.47,0,.71,0h1.76c.24,0,.48,0,.71,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 169.75,
    width: 15.53,
    height: 36.94,
    rx: 6.34,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.36,169.78c-.23,0-.47,0-.71,0h-1.76c-.24,0-.48,0-.71,0v36.88c.23,0,.47,0,.71,0h1.76c.24,0,.48,0,.71,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.63,198.92a7.29,7.29,0,0,0-5.79,3.86c-2.32,3.86-9.65,18.14-8.88,22.39s32.81,34.35,32.81,36.28-25.47,36.67-42.46,52.11-30.49,32.8-32.81,46.7,5.79,25.47,14.29,27.79,18.91-2.7,30.87-17.76,44.78-80.67,49.8-103c0,0,1.15-10-3.48-15.83s-16.21-19.3-16.21-19.3,2.32-26.63.39-28.56-3.86,2.32-3.86,2.32-1.79-8.93-4.25-8.5c-2.69.48-3.47,3.86-3.47,3.86S186.65,193.51,181.63,198.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3,205.87s-5.54,22.17-5,25.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.58,201.23s-5.87,21.56-6.62,24.56a7.39,7.39,0,0,0,.94,5.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.63,198.92s-8.29,23.12-8.29,25.56,1.88,5.43,1.88,5.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25,295.53a203.44,203.44,0,0,1-16.94,18c-17,15.43-30.49,32.8-32.81,46.7s5.79,25.47,14.29,27.79,18.91-2.7,30.87-17.76c6.89-8.66,20.67-34.06,32.09-58.33C184.35,307.31,177.17,300.11,174.25,295.53Z",
    style: {
      fill: "#3B61E1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.47,150.61s-.67,53.73,1.35,63.81,20.15,27.2,41,27.87,37.28-18.47,39.29-28.55,0-50.37-.33-66.49-23.51-30.56-47-26.87S212.13,137.84,213.47,150.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.52,172.44s1.34,9.4,2.69,11.41,3.69,4.71-1,6.72-8.4-.34-8.4-2.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.56,205.68S251.42,208,243.36,200c0,0,2,12.43,8.06,14.45S269.56,205.68,269.56,205.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.05,
    y1: 172.77,
    x2: 247.73,
    y2: 178.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.66,177.81s4.7,3,13.43.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.96,
    y1: 172.77,
    x2: 280.64,
    y2: 178.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,177.81s4.7,3,13.44.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.31,163.37a17.62,17.62,0,0,1,14.1-7.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.55,155.64s9.74-2.68,16.46,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,170h0a9.28,9.28,0,0,1-.12,9.58l-.19.3a15.63,15.63,0,0,1-13.27,7.37h-2.1a12.19,12.19,0,0,1-10.54-6.07h0a10.12,10.12,0,0,1-.58-9h0a10.1,10.1,0,0,1,8.68-6.17l9.56-.6A9.25,9.25,0,0,1,256,170Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,170h0a9.28,9.28,0,0,0,.12,9.58l.19.3a15.63,15.63,0,0,0,13.27,7.37h2.1a12.19,12.19,0,0,0,10.54-6.07h0a10.09,10.09,0,0,0,.58-9h0a10.1,10.1,0,0,0-8.68-6.17l-9.55-.6A9.27,9.27,0,0,0,267,170Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,171.76s3-2.35,8.73,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.1,
    y1: 166.73,
    x2: 269.56,
    y2: 166.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.18,
    y1: 172.17,
    x2: 213.47,
    y2: 172.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.59,136.5s8.7,27.94,21.91,35.16c-.29-9.58-.63-18.58-.75-24.41-.34-16.12-23.51-30.56-47-26.87s-35.6,17.46-34.26,30.23c0,0-.11,8.77-.1,19.9C224.73,165.62,254.59,152,273.59,136.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-48)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.14,163.17S255.19,144.7,279,121.25",
    style: {
      fill: "none",
      stroke: "#737373",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.58,148.25s46.19-10.66,72.84-38.73",
    style: {
      fill: "none",
      stroke: "#737373",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.19,124.44s.71,18.12,19.9,34.82",
    style: {
      fill: "none",
      stroke: "#737373",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.19,237.19s0,12.18-9.13,31.59-9.52,38.82-3.43,53.28,22.46,20.18,40,13.71,19.79-35.4,17.89-52.91-19-38.06-22.84-48.34-6.47-15.6-6.47-15.6-9.9,13.7-16,16.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-48)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.61,223.57a95.61,95.61,0,0,1-6.39,49c-10.66,25.58-2.49,52.94,9.95,58.62s24.51,3.56,30.55-4.26",
    style: {
      fill: "none",
      stroke: "#737373",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,217.89s12.08,28.42,7.11,49.74S292.5,316,307.42,321.28,330.87,316,330.87,316",
    style: {
      fill: "none",
      stroke: "#737373",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,236.36s10.3,39.08,10.3,59.33,12.44,17.06,15.64,7.11",
    style: {
      fill: "none",
      stroke: "#737373",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.19,237.19s0,12.18-9.13,31.59-9.52,38.82-3.43,53.28,22.46,20.18,40,13.71,19.79-35.4,17.89-52.91-19-38.06-22.84-48.34-6.47-15.6-6.47-15.6-9.9,13.7-16,16.74Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.03,
    y: 343.56,
    width: 75.36,
    height: 100.1,
    rx: 5.19,
    transform: "translate(16.07 -11.34) rotate(2.31)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.24,381.19S324,370.85,318.33,369.11,280,391.76,278.7,395.24s3.48,3.49,3.48,3.49-2,3.48,1,5.22a18,18,0,0,0,3,1.63s-1.74,3.92,1.74,5.23,8.28-2.18,8.28-2.18l7.84-5.66s-9.42,11.53-7.41,13.94c2.77,3.3,4.54-.24,4.54-.24L312,403.84l10.88-5.23s8.71,5.23,22.65,5.66,17-5.66,17-5.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25,405.58s12.21-8.38,15.25-11.41,12.89-9.36,15.93-9.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,403s6-6.78,8.26-7.79,5.56-2.53,5.56-2.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.18,398.73s17-12,22.82-15.53a82.17,82.17,0,0,1,10.87-5.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbConversationsEtrangere);
export default __webpack_public_path__ + "static/media/nb_conversations_etrangere.4e687c96f4ad828281bbe8f29be1400f.svg";
export { ForwardRef as ReactComponent };